import clsx from 'clsx';
import { Switch } from '@mui/material';
import FuseSvgIcon from '@fuse/core/FuseSvgIcon';

interface IProps {
  status: string;
  className?: string;
  isApproved?: boolean;
  onIsApprovedChange?: (newValue: boolean) => void;
}

const AffiliateLeadStatusComponent = ({
  status,
  className = 'text-12',
  isApproved,
  onIsApprovedChange,
}: IProps) => {
  const baseClass = clsx('flex items-center', className);
  switch (status) {
    case 'Draft':
      return (
        <span className={clsx(baseClass, 'justify-start mr-8')}>
          <FuseSvgIcon color="disabled">material-outline:edit</FuseSvgIcon>
        </span>
      );
    case 'Uploaded':
      return (
        <span className={clsx(baseClass, 'justify-center')}>
          <FuseSvgIcon color="success">material-outline:task</FuseSvgIcon>
          <Switch
            checked={isApproved || false}
            onChange={(event) => {
              onIsApprovedChange && onIsApprovedChange(event.target.checked);
            }}
            inputProps={{ 'aria-label': 'controlled' }}
          />
        </span>
      );
    case 'Processing':
      return (
        <span className={clsx(baseClass, 'justify-center')}>
          <FuseSvgIcon color="action">material-outline:hourglass_empty</FuseSvgIcon>
        </span>
      );
    case 'Failed':
      return (
        <span className={clsx(baseClass, 'justify-center text-red-600')}>
          <FuseSvgIcon color="error">material-outline:error_outline</FuseSvgIcon>
        </span>
      );
    default:
      return <span className={clsx(baseClass, 'bg-[#ED661A] justify-center')}>{status}</span>;
  }
};

export default AffiliateLeadStatusComponent;
